import { CreateStep7Body, StepToReturnEnum } from "../../../types/cto/step7";
import { MOCK_LONG_TEXT } from "../genericMocks";

export const dataStep7Body: CreateStep7Body = {
  proceed_for_closure: true,
  step_to_return: StepToReturnEnum.STEP_5,
  verification_comment: MOCK_LONG_TEXT,
  draft: false,
};
